"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var UpdateConstraintSerialiser = require("./update-constraint-serialiser");
/**
 * Serialiser for {@link CreateUpdateStreamAndSetRequest}
 */
var CreateUpdateStreamAndSetRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(CreateUpdateStreamAndSetRequestSerialiserClass, _super);
    function CreateUpdateStreamAndSetRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link CreateUpdateStreamAndSetRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link CreateUpdateStreamAndSetRequest} to be written
     */
    CreateUpdateStreamAndSetRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        BEES.write(bos, value.topicType);
        Codec.writeBytes(bos, value.value);
        UpdateConstraintSerialiser.write(bos, value.constraint);
    };
    return CreateUpdateStreamAndSetRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.CreateUpdateStreamAndSetRequestSerialiserClass = CreateUpdateStreamAndSetRequestSerialiserClass;
/**
 * The {@link CreateUpdateStreamAndSetRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CreateUpdateStreamAndSetRequestSerialiser = new CreateUpdateStreamAndSetRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/create-update-stream-and-set-request-serialiser.js
// module id = 2052
// module chunks = 1